import { format as formatDate, isValid, parseISO } from 'date-fns';

const format = ( option ) => {
  switch ( option ) {
    case '':
      return 'no rush';
    case 'tomorrow':
      return 'tomorrow';
    case 'this_week':
      return 'this week';
    case 'next_week':
      return 'next week';
    default: {
      const d = parseISO( option );

      return isValid( d ) ? formatDate( d, 'P' ) : null;
    }
  }
};

export const OptionFormatter = {
  format,
};
